import { isSameDay } from 'date-fns';
import { DiscountType } from '~/models/DiscountModel';
import styles from '../../BillClientModal/BillClientModal.module.scss';
export const validateGreaterThan0 = (value)=>value && +value > 0;
export function getTableInfo(params) {
    const { discount, tableHeaders } = params;
    const tableInfo = [
        {
            headerItem: {
                value: tableHeaders.serviceName()
            },
            columnDef: {
                width: 248
            }
        },
        {
            headerItem: {
                value: tableHeaders.quantity(),
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: tableHeaders.rate(),
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: discount.type === DiscountType.Percent ? tableHeaders.discount() : tableHeaders.unitDiscount(),
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: null
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: tableHeaders.total(),
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: [
                    130,
                    276
                ]
            }
        }
    ];
    return {
        columnDefs: tableInfo.map((i)=>i.columnDef),
        headerItems: tableInfo.map((i)=>i.headerItem)
    };
}
export function getClientApprovalCalloutText(params) {
    const { issueDate, invoiceDateInfo, calloutTexts } = params;
    return (invoiceDateInfo === null || invoiceDateInfo === void 0 ? void 0 : invoiceDateInfo.invoiceDraftDates.dates().some((d)=>isSameDay(d, issueDate))) ? calloutTexts.existingInvoice() : calloutTexts.newInvoice();
}
